import ProjectsComponent from '../ProjectsComponent.vue'
import ViewCompanyComponent from '../ViewCompanyComponent.vue'

export default [
    {
        path: '/projects',
        name: 'Projects',
        meta: { layout: 'default' },
        component: ProjectsComponent,
    },
    {
        path: '/view_project/:id',
        name: 'ViewProject',
        meta: { layout: 'default' },
        component: ViewCompanyComponent,
    }
]
